import React from 'react';

export const TipoEtapa = {
  GRUPOS: false,
  DEFINICION: true,
};

const CampoOptionsTipoEtapa = (props) => {
  const estilo = props.estilo;
  const editar = props.editar;
  const nombre = props.nombre;
  const valor = props.valor;

  const onChangeHandler = (event) => {
    const boolValue = event.target.value === 'true';
    props.onChange(nombre, boolValue);
  };

  let campo = '';
  if (editar) {
    campo = (
      <div className={`${estilo}`}>
        <label>
          <input
            type="radio"
            name="tipoEtapa"
            value="false"
            checked={valor === false}
            onChange={onChangeHandler}
          />{' '}
          Grupos
        </label>
        {'  '}
        <label>
          <input
            type="radio"
            name="tipoEtapa"
            value="true"
            checked={valor === true}
            onChange={onChangeHandler}
          />{' '}
          Definición
        </label>
      </div>
    );
  } else {
    campo = valor === true ? 'Definición' : 'Grupos';
  }

  return <React.Fragment>{campo}</React.Fragment>;
};

export default CampoOptionsTipoEtapa;
